import * as React from 'react';
import './CompanyScore.css';
import Radial from './Radial';

interface Props {
    color: string;
    percentFill: number;
    directionalValue?: true;
    tooltipEnabled?: boolean;
    message?: string;
}

function nonDirectionalValueData(percentFill: number, color: string) {
    return [
        {
            name: '18-24',
            value: percentFill,
            fill: `#${color}`
        },
        {
            name: '18-24',
            value: 100,
            fill: `#${color}`
        }
    ];
}

function directionalValueData(negative: boolean, percentFill: number, color: string) {
    return [
        {
            name: '18-24',
            value: negative ? Math.abs(percentFill) : percentFill,
            fill: `${negative ? '#9f0800' : '#2c9452'}`
        },
        {
            name: '18-24',
            value: 100,
            fill: `#${color}`
        }
    ];
}

function getDataFormat(directionalValue: boolean, color: string, percentFill: number, negative: boolean) {
    if (directionalValue) {
        return directionalValueData(negative, percentFill, color);
    } else {
        return nonDirectionalValueData(percentFill, color);
    }
}

function isNegative(percentage: number) {
    return -1 === Math.sign(percentage);
}

class RadialbarChart extends React.Component<Props> {
    render() {
        const { color, percentFill, directionalValue = false, tooltipEnabled = false, message } = this.props;
        const negative = isNegative(percentFill);
        const data = getDataFormat(directionalValue, color, percentFill, negative);

        return (
            <Radial
                data={data}
                negative={negative}
                tooltipEnabled={tooltipEnabled}
                message={message}
            />
        );
    }
}

export default RadialbarChart;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/results/RadialbarChart.tsx